define([
    'text!product-detail/component/feature-item3.html',
    'product-detail/component/images-box',
    'common/utils'
], function(
    tpl,
    ImagesBox,
    Utils
){
    return {
        template: tpl,
        components: {
            ImagesBox: ImagesBox
        },
        props: {
            item: {
                type: Object
            },
            index: {
                type: String
            }
        },
        data: function(){
            return {
                options: {
                    centerMode: true,
                    centerPadding: '20px',
                    slidesToShow: 3,
                    infinite: true,
                    slidesToScroll: 3
                }
            };
        },
        methods: {
            ln2br: Utils.ln2br
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/feature-item3.js
// module id = 271
// module chunks = 0